// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__HvtyU","notes":"Notes_notes__kILxs","note":"Notes_note__13dUc","markdown":"Notes_markdown__1Tlf4"};